/* eslint-disable */

import axios from 'axios';
import { storeLoginData, getLoginData, removeLoginData, isLoggedIn } from "../utils/loginSession";

let token = getLoginData()?.token;

const api = axios.create({

  baseURL: process.env.REACT_APP_BASE_URL_NEW,
  headers: {
    // 'Content-Type': 'multipart/form-data',
  },
});

export const uploadImage = async (endpoint, imageUri) => {
  token = getLoginData()?.token;
  const formData = new FormData();
  formData.append('file', {
    uri: imageUri,
    name: 'photo.jpg', // or any name for the file
    type: 'image/jpeg', // or the correct MIME type
  });

  try {
    const response = await api.post(endpoint, formData);
    return response.data;
  } catch (error) {
    console.error('Upload error:', error);
    if (error.response) {

      throw error.response.data.error || error.response.data.message;
    }
    else {
      throw error;
    }
    throw error;
  }
};

// export const post = async (endpoint, data, imageData = []) => {

//   try {
//     console.log(endpoint)
//     let headers = {}
//     if (token) {
//       headers = { 'Authorization': `Bearer ${token}` };
//     }
//     const response = await api.post(endpoint, data,
//       {
//         headers: headers
//       }
//     );

//   } catch (error) {
//     console.error('Upload error:', error);
//     throw error;
//   }
// };


export const post = async (endpoint, data,) => {
  token = getLoginData()?.token;
  try {
    console.log(endpoint, data)
    let headers = {}
    if (token) {
      headers = { 'Authorization': `Bearer ${token}` };
    }
    const response = await api.post(endpoint, data,
      {
        headers: headers
      }
    );
    return response.data.data;
  } catch (error) {
    if (error.response) {

      throw error.response.data.error || error.response.data.message;
    }
    else {
      throw error;
    }
  }
};
export const put = async (endpoint, data, imageData = []) => {
  token = getLoginData()?.token;
  try {
    console.log(endpoint)
    // const token = getLoginData()?.token

    let headers = {}
    if (token) {
      headers = { 'Authorization': `Bearer ${token}` };
    }
    const response = await api.put(endpoint, data,

      {
        headers: headers
      }
    );
    return response.data.data;
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

export const postWithImage = async (endpoint, data,) => {
  token = getLoginData()?.token;
  try {
    var headers;
    console.log(data)
    if (token) {
      headers = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };
    }
    else {
      headers = {
        "Content-Type": "multipart/form-data",
      };
    }
    const response = await api.post(endpoint, data,
      {
        headers: headers
      }
    );

    return response.data.data;
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }

};

export const get = async (endpoint) => {
  try {

    let headers = {}

    if (token) {
      headers = { 'Authorization': `Bearer ${token}` };
    }
    const response = await api.get(endpoint, {
      headers: headers
    });
    return response.data.data;
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};
